export default __webpack_public_path__ + "static/media/ic-mail.39e03bf1.svg";